import { observer } from 'mobx-react-lite'
import type { LocationProductType } from 'app/types/entities'
import { useAuthStore } from 'app/stores/StoreContext'

// observer: reads authStore.products in render. products is reassigned in place on
// a workspace switch (AuthStore.switchWorkspace -> fetchMe), so without observer the
// product gate would keep the previous workspace's result (TRK-6020).
export const Product = observer(function Product(props: { type: LocationProductType; children: any }) {
  const { products } = useAuthStore()
  if (products?.includes(props.type)) {
    return <>{props.children}</>
  } else {
    return <></>
  }
})
